module.exports = __webpack_public_path__ + "static/media/facebook.b5d9f26f.svg";